import type { IPropertyBag } from '@deity-io/di-data-basics';
import { SystemException } from '@deity-io/di-data-basics';
import { ConfigurationVariables } from '@deity-io/di-data-flows';
// env.gatewayUrl
// package.accountUUid
// component.XXXX

export const handleBarsRegEx = ConfigurationVariables.regEx;
const pathSeparator = '.';

export const replaceHandleBars = (
  description: string,
  values: IPropertyBag,
  options?: {
    missesOutput?: Array<string>;
    onHandleMiss?: (miss: string) => string | undefined;
    onHit?: (hit: string, value: string) => void;
  }
): string => {
  const newDescription = description.replace(handleBarsRegEx, match => {
    try {
      const path = match.slice(1, -1).split(pathSeparator);
      let current = values;
      path.forEach(part => {
        if (part in current) {
          current = current[part];
        } else {
          throw new SystemException('Missing path');
        }
      });
      if (options?.onHit) {
        options?.onHit(match, `${current}`);
      }

      return `${current}`;
    } catch (ex) {
      if (options?.onHandleMiss) {
        const replacement = options.onHandleMiss(match);
        if (replacement !== undefined) {
          return `${replacement}`;
        }
      }
      options?.missesOutput?.push(match);

      return match;
    }
  });

  // if (options?.missesOutput?.length) {
  //   console.log(options.missesOutput);
  // }
  return newDescription;
};
